<template>
  <editor
    :structure="orderedUnpublishedStructure"
    :dragElements="dragElements"
    :showTabs="true"
    :limitEditing="false"
    :shouldIncludeSubmit="false"
    :editorName="'LeadMask'"
    @save="save"
    @publish="publish"
  />
</template>
<script>
import ProjectApi from '@/api/Project.js'
import Drag from '@/classes/Drag'
import Mask from '@/classes/Mask'
import Editor from '@/components/helpers/DragNDrop/Editor'
import Ui from '@/classes/Ui'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    item_saved: {
      type: Object,
      required: true
    }
  },
  components: {
    Editor
  },
  data() {
    return {
      dragElements: [Drag.generateDefaultElements('lead_sheet')]
    }
  },
  computed: {
    dragEditorEdited() {
      return this.$store.getters.getDragEditorEdited
    },
    orderedUnpublishedStructure() {
      let structure       = this.item.unpublished_structure
      let clonedStructure = _.cloneDeep(structure)
      let fields          = Mask.listFields(structure)
      let array           = [...Object.values(fields)]
      // Sort by position value of objects
      array.sort(function(a,b) {
        return Number(a.position) - Number(b.position);
      });
      return array
    },
  },
  async mounted() {
    this.setupHeader()
  },
  beforeRouteLeave(to, from, next) {
    if (this.dragEditorEdited) {
      let shouldLeave = window.confirm(this.$t('ui.drag_editor.popup.unsaved_changes'))
      if (shouldLeave) {
        this.setEdited(false)
        this.removeHeaderButtons()
      }
      next(shouldLeave)
    } else {
      this.removeHeaderButtons()
      next()
    }
  },
  methods: {
    removeHeaderButtons() {
      Ui.setHeaderButtons([])
    },
    setupHeader() {
      Ui.setHeaderButtons([
        { name: "lead_mask_save", action: "lead_mask.save", classes: "btn-tertiary"},
        { name: "lead_mask_publish", action: "lead_mask.publish", classes: "btn-primary"}
      ])
    },
    save(structureArray) {
      let structure = Drag.arrayToStructure(_.cloneDeep(structureArray))
      this.item.unpublished_structure = structure
      this.$emit('update', this.item)
      this.setEdited(false)
    },
    publish(structureArray) {
      let structure = Drag.arrayToStructure(structureArray)
      this.item.unpublished_structure = structure
      this.item.structure = structure
      this.$emit('update', this.item)
      this.setEdited(false)
    },
    setEdited(bool) {
      this.$store.commit('SET_DRAG_EDITOR_EDITED', bool)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LeadMaskEditor.vue?e3b0117c